export const RECAPTCHA_SITE_KEY="6Le4Kn4eAAAAAHsc4b1ocsdrcVoUlJ4pHtlQd2wk"
export const DMS_API_TOKEN = "cDoZnaXTrpBVHxtYmDJtVtnW"
export const PAYZEE_USER_CODE = "samet.atar@honda-eu.com";
export const PAYZEE_AMOUNT = "5000000"
export const breadcrumbArr = [{name:"Model"},{name:"Versiyon"},{name:"Tasarım"},{name:"Kişisel Bilgiler ve Teslimat"},{name:"Özet"},{name:"Ödeme"}]
export const SUB_MERCHANTID = 1914

